import * as React from 'react';

const ErrorIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="47"
    height="46"
    fill="none"
    viewBox="0 0 47 46"
  >
    <path
      stroke="#DF3F1F"
      strokeLinecap="round"
      strokeWidth="3.028"
      d="M23.311 15.3v10.407m0 5.866v-.189m17.031-8.515c0 9.406-7.625 17.03-17.03 17.03-9.407 0-17.032-7.624-17.032-17.03S13.905 5.838 23.311 5.838s17.031 7.625 17.031 17.03Z"
    ></path>
  </svg>
);

export default ErrorIcon;
